import { render, staticRenderFns } from "./RegistComponent.vue?vue&type=template&id=3c6ff19c&scoped=true&"
import script from "./RegistComponent.vue?vue&type=script&lang=js&"
export * from "./RegistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ff19c",
  null
  
)

export default component.exports